// Textos de la fase 4 de flotas de taxi/VTC (docs/flotas-drivers): tipos de
// flota, emisora (paradas, zonas y reparto), cuota al pasajero y retos. Se
// registran en AppComponent y se fusionan con drivers-fleet/es.ts.
export const locale = {
  lang: 'es',
  data: {
    DRIVERS_FLEET: {
      KIND: {
        dispatch_center: 'Emisora de taxi',
        owner_operator: 'Taxista patrón',
        vtc_fleet: 'Flota VTC',
      },
      EMPLOYMENT_TYPE: {
        associate: 'Socio',
      },
      DEMAND_CHANNEL: {
        waiis_app: 'App WAIIS',
        emitter_phone: 'Teléfono de la emisora',
        emitter_web: 'Web de la emisora',
        stand: 'Parada',
        street_hail: 'En la calle',
      },
      SERVICE_TYPE: {
        immediate: 'Inmediato',
        reservation: 'Reserva',
        airport_premium: 'Premium o aeropuerto',
      },
      DISPATCH_STRATEGY: {
        proximity: 'El más cercano',
        stand_order: 'Orden de la parada',
        zone: 'Por zona',
      },
      CHALLENGE_STATUS: {
        draft: 'Borrador',
        scheduled: 'Programado',
        active: 'En marcha',
        finished: 'Terminado',
        cancelled: 'Cancelado',
      },
      SIGNUP: {
        KIND_TITLE_dispatch_center: 'Emisora de taxi',
        KIND_TITLE_owner_operator: 'Propietario de licencias de taxi',
        KIND_TITLE_vtc_fleet: 'Ofrecer viajes con licencias VTC',
        KIND_HINT_dispatch_center: 'Asociación o radio taxi: tus socios tienen licencia y coche propios. Paradas, zonas y reparto.',
        KIND_HINT_owner_operator: 'Una o más licencias municipales, con conductores que las trabajan por turnos.',
        KIND_HINT_vtc_fleet: 'Empresa u operador con autorizaciones VTC, con conductores asalariados o autónomos.',
      },
      GEO: {
        TOOLS_ARIA: 'Herramientas del mapa',
        DRAW: 'Dibujar',
        PLACE_POINT: 'Colocar el punto',
        UNDO: 'Deshacer',
        CLEAR: 'Borrar',
        RECENTER: 'Encuadrar',
        ZOOM_IN: 'Acercar',
        ZOOM_OUT: 'Alejar',
        HINT_START: 'Pulsa en el mapa para añadir puntos ({{count}} de 3 como mínimo).',
        HINT_EDIT: 'Arrastra un punto para moverlo; doble clic para quitarlo. Pulsa en el mapa para añadir más.',
        HINT_POINT: 'Pulsa en el mapa o arrastra el marcador para colocar el punto de la parada.',
        HINT_INVALID: 'Los lados de la zona se cruzan: mueve o quita algún punto.',
        POLYGON_REQUIRED: 'Dibuja la zona con al menos 3 puntos y sin que sus lados se crucen.',
      },
      OPS: {
        SAVE: 'Guardar',
        SHIFTS: {
          SUB: 'Se repiten cada semana. Pulsa una casilla para cambiar quién conduce ese coche ese día.',
          CHANGE_HOURS: 'Cambiar horas',
          NO_DRIVER: 'Sin conductor',
          FIXED: 'Turno fijo',
          REPEAT: 'Repetir',
          DAY_LETTER: { 1: 'L', 2: 'M', 3: 'X', 4: 'J', 5: 'V', 6: 'S', 7: 'D' },
          CLASH: '{{name}} ya tiene turno de {{slot}} en otro coche alguno de esos días.',
          PICK_DAY: 'Elige al menos un día.',
          CONFLICT: 'Hay un conductor en dos coches a la vez. Revisa los turnos.',
          SAVED_TITLE: 'Turno guardado',
          SAVED_FROM: 'Se aplica desde el {{date}}.',
        },
        VEHICLES: {
          KPIS_ARIA: 'Resumen de los vehículos',
          KPI_ON_STREET: 'En la calle ahora',
          KPI_ALERTS: 'ITV o seguro en menos de 45 días',
          TAB_ON_STREET: 'En la calle',
          TAB_PARKED: 'Parados',
          TAB_WITHOUT_DRIVER: 'Sin conductor',
          TAB_WITH_ALERTS: 'Con avisos',
          SEARCH: 'Buscar matrícula o modelo',
          COL_VEHICLE: 'Vehículo',
          COL_KM: 'Km',
          PRESENCE_on_street: 'En la calle',
          PRESENCE_parked: 'Parado',
          NEXT_UPLOAD: 'Falta subir documentos',
          NEXT_SUBMIT: 'Listo para enviar a revisión',
          NEXT_FIX: 'Vuelve a subir lo rechazado',
          NEXT_WAIT: 'Lo revisamos en menos de 24 h',
          N_SHIFTS: '{{count}} turnos',
          ASSIGN: 'Asignar conductor',
          COMPLETE: 'Completar',
          EMPTY: 'Aún no hay vehículos. Matrícula, licencia y 4 documentos: los revisamos en 24 h.',
          ADD_SUB: 'Lo revisamos en menos de 24 h.',
          REJECTED_NOTE: 'Hay un documento rechazado. Súbelo de nuevo y el coche vuelve a revisión.',
          MUNICIPALITY: 'Municipio de la licencia',
          MORE_DATA: 'Marca, modelo, año, plazas y km',
          YEAR: 'Año',
          KM_HINT: 'Lo actualiza la app del conductor; aquí puedes corregirlo.',
          DATA_INVALID: 'Revisa el año (de 1990 en adelante) y las plazas (de 1 a 8).',
          NO_DRIVERS: 'Nadie conduce este coche todavía.',
          EDIT_SHIFTS: 'Editar turnos',
          DOCS_COUNT: 'Documentos {{done}}/{{total}}',
          DOC_PENDING: 'Pendiente',
          DOC_UPLOADED: 'Subido',
          DOC_IN_REVIEW: 'En revisión',
          DOC_REJECTED: 'Rechazado: {{reason}}',
          DOC_UNTIL: 'Válido hasta el {{date}}',
          DOC_VALID: 'Válido',
          CHECKS: {
            circulation_permit: 'Las dos caras|Se ven las 4 esquinas|Matrícula legible',
            technical_sheet_itv: 'Las dos caras|Fecha de la próxima ITV visible|Sin tachones ni reflejos',
            insurance_policy: 'Todas las páginas|Caducidad y matrícula legibles|Responsabilidad civil incluida',
            taxi_municipal_license: 'Número y municipio visibles|Vigente|Una por vehículo',
            vtc_transport_card: 'Del mismo vehículo que el permiso de circulación|Número de autorización legible|Una por vehículo',
          },
          DOCS_AFTER: 'Guarda los datos y después sube los 4 documentos.',
          SUBMIT_HINT: 'Con los 4 documentos subidos, envíalo a revisión. Mientras tanto queda incompleto.',
          SAVE_AND_DOCS: 'Guardar y subir documentos',
          SAVE_LATER: 'Guardar y seguir luego',
          SUBMIT: 'Enviar a revisión',
          SUBMIT_DISABLED: 'Sube los 4 documentos para enviarlo.',
          SUBMITTED_TITLE: '{{plate}} enviado a revisión',
          SUBMITTED_TEXT: 'Lo revisamos en menos de 24 h. Te avisamos cuando pueda trabajar.',
          MISSING_DOCS: 'Faltan documentos por subir.',
        },
        OVERVIEW: {
          NOW_TITLE: 'Ahora',
          NOW_SUB: '{{count}} conductores conectados. Se actualiza cada 30 segundos.',
          NOW_LIVE: 'En directo',
          NOW_STALE: 'Sin conexión: datos de hace un rato',
          SEE_DRIVERS: 'Ver conductores',
          ATTENTION_EMPTY: 'Todo en orden: nada pendiente.',
          ATTENTION_document_expired: 'Documento caducado',
          ATTENTION_document_rejected: 'Documento rechazado',
          ATTENTION_driver_without_vehicle: 'Conductor sin coche',
          ATTENTION_driver_request: 'Solicitud para unirse',
          ATTENTION_GO_document_expired: 'Renovar',
          ATTENTION_GO_document_rejected: 'Volver a subir',
          ATTENTION_GO_driver_without_vehicle: 'Asignar',
          ATTENTION_GO_driver_request: 'Revisar',
          ATTENTION_MORE: 'Y {{count}} más.',
          EXPIRED_ON: 'caducó el {{date}}',
          REQUESTED_ON: 'pedido el {{date}}',
          WEEK_TITLE: 'Esta semana',
          WEEK_SUB: 'Del {{from}} al {{to}} · {{trips}} viajes',
          WEEK_GO: 'Ver liquidación',
          WEEK_FARE: 'Ingresos',
          WEEK_SHARE: 'Reparto a conductores',
          WEEK_NET: 'Neto de la flota',
          WEEK_PAYOUT: 'Se liquida el {{date}}',
          AVERAGE: 'Media',
          CHART_INSIGHT: '{{total}} viajes, {{average}} al día de media. El mejor día fue el {{day}}, con {{trips}}.',
          TOP_TITLE: 'Conductores con más viajes',
          TOP_Q: 'Los 4 que más han trabajado en los últimos {{days}} días.',
          TOP_HOURS: '{{hours}} h conectado',
          START_VEHICLE: 'Añade un vehículo',
          START_VEHICLE_HINT: 'Su matrícula, la licencia y los documentos del coche.',
          START_CODE: 'Comparte el código con tus conductores',
          START_CODE_HINT: 'Lo meten en la app WAIIS Driver y te llega su solicitud.',
          START_SHIFTS: 'Asigna los turnos',
          START_SHIFTS_HINT: 'Quién conduce cada coche por la mañana, por la tarde y por la noche.',
          START_SHIFTS_LOCKED: 'Primero necesitas un coche y un conductor aceptado.',
          FLEET_TITLE: 'Tu flota',
          FLEET_SUB: 'Cómo va todo mientras WAIIS revisa el alta.',
          TO_ACCEPT: 'Por aceptar',
          SETTLEMENTS_ON_APPROVAL: 'Se activan cuando WAIIS apruebe la flota.',
        },
        DOCUMENTS: {
          KPIS_ARIA: 'Resumen de documentos',
          KPI_STOPPED: 'Caducados o rechazados',
          KPI_EXPIRING: 'Caducan en 45 días',
          VEHICLES_SUB: 'Primero lo más urgente. Pulsa un documento para verlo o subir uno nuevo.',
          FISCAL: 'Datos fiscales',
          VERIFIED: 'Verificados',
          VALID: 'Válido',
          APPROVED_ON: 'Aprobado el {{date}}',
          CELL_BAD: 'Caducado',
          CELL_REJ: 'Rechazado',
          CELL_WARN: 'Caduca pronto',
          CELL_REV: 'En revisión',
          CELL_NONE: 'Falta',
          CELL_OK: 'Al día',
          UPLOAD_SHORT: 'Subir',
          UPCOMING_TITLE: 'Próximas caducidades',
          UPCOMING_SUB: 'Próximos 4 meses',
          UPCOMING_EMPTY: 'Nada caduca en los próximos 4 meses.',
          EXPIRED_ON: 'Caducó el {{date}}',
          EXPIRES_ON: 'Caduca el {{date}}',
          CAR_STOPPED: ', coche parado',
          TODAY: 'hoy',
          DAYS_AGO: 'hace {{count}} días',
          DAYS_AGO_ONE: 'hace 1 día',
          IN_DAYS: 'en {{count}} días',
          IN_DAYS_ONE: 'en 1 día',
          REVIEW_SUB: 'Lo revisamos en menos de 24 h.',
          REVIEW_EMPTY: 'Nada enviado todavía.',
          DRIVER_DOCS_NOTE: 'Los documentos de los conductores los sube cada uno desde la app. Los ves en su ficha.',
          NOTE_BAD: 'Caducado. El coche no puede salir hasta que subas el nuevo.',
          NOTE_REJ: 'Rechazado. Revisa el motivo y súbelo de nuevo.',
          NOTE_WARN: 'Caduca pronto. Súbelo renovado y lo revisamos en 24 h.',
          NOTE_REV: 'En revisión. Normalmente tardamos menos de 24 h.',
          NOTE_NONE: 'Falta este documento.',
          NOTE_OK: 'Al día.',
          NOTE_FISCAL_OK: 'Verificados por WAIIS.',
          LEGAL_NAME: 'Razón social',
          TAX_ID: 'CIF o NIF',
          ADDRESS: 'Dirección fiscal',
          FISCAL_EMPTY: 'Todavía no has rellenado los datos fiscales.',
          FISCAL_HINT: 'Se cambian en Ajustes; si cambian, WAIIS los vuelve a revisar.',
          GO_SETTINGS: 'Ir a Ajustes',
          CURRENT_FILE: 'Archivo actual',
          UPLOAD_FIRST: 'Subir el documento',
          UPLOAD_NEW: 'Subir uno nuevo',
          SAMPLE: 'Lo que revisamos',
          CHECKS: {
            bank_ownership_certificate: 'IBAN y titular visibles|A nombre de la empresa|Se ven las 4 esquinas',
            route_sheet_authorization: 'Se ven tu NIF y el de WAIIS|Tipo Intermediario / Plataforma',
          },
        },
        SETTLEMENTS: {
          INFO_TEXT: 'Los pagos a conductores desde la wallet llegarán más adelante. Aquí ves el extracto, lo que le toca a cada conductor y los movimientos.',
          STATEMENT: 'Extracto',
          STATEMENT_EXPORT: 'Extracto',
          STATEMENT_ERROR: 'No se ha podido cargar el extracto.',
          PREVIOUS: 'Periodo anterior',
          NEXT: 'Periodo siguiente',
          PERIOD_ARIA: 'Periodo',
          PERIOD_WEEK: 'Semana',
          PERIOD_MONTH: 'Mes',
          OPENING: 'Saldo inicial',
          TRIPS: 'Viajes',
          TRIPS_COUNT: '{{count}} viajes',
          TOLLS: 'Peajes',
          TOLLS_SUB: 'Reembolsados por el pasajero',
          DRIVER_SHARE: 'Reparto a conductores',
          CANCELLATIONS: 'Cancelaciones cobradas',
          PAYOUTS: 'Liquidado a tu cuenta',
          CLOSING: 'Saldo final',
          AVAILABLE_ON: 'Disponible el {{date}}',
          FEE_INFO: 'Cuota de los pasajeros: {{amount}}. La pagan ellos encima de la tarifa; no se descuenta de tu saldo.',
          BY_DRIVER: 'Reparto por conductor',
          BY_DRIVER_SUB: '{{amount}} en total. Los asalariados no salen: no tienen reparto.',
          BY_DRIVER_EMPTY: 'Nadie con reparto en este periodo.',
          COL_GENERATED: 'Generado',
          COL_SHARE: 'Reparto',
          COL_PAYABLE: 'A pagar',
          COL_STATUS: 'Estado',
          STATUS_PAID: 'Pagado',
          STATUS_PENDING: 'Pendiente',
          PAID_AT: 'Pagado el {{date}}',
          WALLET: 'Wallet de la flota',
          HELD: 'Retenido',
          HELD_UNTIL: 'Retenido hasta el {{date}}',
          SHARE_SUB: 'Lo que se queda el conductor. Puedes cambiarlo en la ficha de cada uno.',
          SHARE_HINT: 'Los asalariados no tienen reparto. No cambia el de los conductores ya aceptados.',
          SAVED: 'Guardado',
          WAITING_TITLE: 'Se activan al aprobar la flota',
          WAITING_TEXT: 'Cada lunes verás el saldo de la semana y el reparto por conductor.',
          WAITING_IBAN: 'Cobras en {{iban}}.',
        },
        PERFORMANCE: {
          NO_DATA_TITLE: 'Aún no hay datos',
          NO_DATA_TEXT: 'Aparecerán cuando tus conductores empiecen a hacer viajes.',
          KPIS_ARIA: 'Rendimiento de las últimas 4 semanas',
          KPI_RATING: 'Valoración media',
          KPI_ACCEPTANCE: 'Aceptación',
          KPI_CANCELLATION: 'Cancelación del conductor',
          KPI_FARE_HOUR: '€ por hora conectado',
          DRIVERS_SUB: 'Últimas 4 semanas.',
          SORT_ARIA: 'Ordenar por',
          SORT_FARE_PER_HOUR: '€ / hora',
          SORT_RATING: 'Valoración',
          SORT_ACCEPTANCE_RATE: 'Aceptación',
          SORT_TRIPS: 'Viajes',
          COL_FARE_HOUR: '€ / h',
          COL_CANCELLATION: 'Cancel.',
          DEMAND_TITLE: 'Horas con más demanda',
          DEMAND_SUB: 'Viajes por hora, media de {{weeks}} semanas.',
          DEMAND_TIP: '{{hour}} h: {{trips}} viajes',
          PEAK: 'De {{from}} a {{to}} h es cuando más se pide: {{trips}} viajes por hora.',
          PEAK_PARKED: 'De {{from}} a {{to}} h tienes {{parked}} coches parados y {{trips}} viajes por hora. Es donde más se nota un turno extra.',
        },
        REPORTS: {
          MONTHS_ARIA: 'Mes',
          CLOSED_ON: 'Cerrado el {{date}}',
          OPEN: 'Mes en curso',
          PAID_DRIVERS: 'Pagado a conductores',
          DRIVERS_COUNT: '{{count}} conductores',
          NET: 'Neto de la flota',
          FEE: 'Cuota de los pasajeros',
          FEE_SUB: 'Solo como dato',
          DOWNLOAD_TITLE: 'Descargar',
          DOWNLOAD_SUB: 'Del mes seleccionado.',
          REPORT_trips: 'Viajes',
          REPORT_trips_HINT: 'Conductor, vehículo, importe, canal y cuota de cada viaje',
          REPORT_driver_settlements: 'Liquidación por conductor',
          REPORT_driver_settlements_HINT: 'Un PDF por conductor, listo para la gestoría',
          REPORT_route_sheets: 'Hojas de ruta',
          REPORT_route_sheets_HINT: 'Lo comunicado al Ministerio por vehículo',
          COUNT_ROWS: '{{count}} filas',
          COUNT_FILES: '{{count}} archivos',
          COUNT_VEHICLES: '{{count}} vehículos',
          FILE_trips: 'viajes',
          FILE_driver_settlements: 'liquidaciones_conductores',
          FILE_route_sheets: 'hojas_de_ruta',
          PAST_TITLE: 'Meses anteriores',
          COL_MONTH: 'Mes',
          ACCOUNTANT_TITLE: 'Gestoría',
          MONTHLY_EMAIL: 'Enviar la liquidación cada mes',
          MONTHLY_EMAIL_SUB: 'El día 1, la del mes cerrado.',
          EMAIL: 'Correo de la gestoría',
          EMAIL_PLACEHOLDER: 'gestoria@ejemplo.com',
          EMAIL_INVALID: 'Escribe un correo válido.',
          EMAIL_REQUIRED: 'Escribe el correo de la gestoría para activar el envío.',
          ACCOUNTANT_ACCESS: 'Acceso directo al panel',
          ACCOUNTANT_ACCESS_SUB: 'Invítala en Equipo con el rol Contable.',
        },
        TEAM: {
          INVITE: 'Invitar',
          INVITE_TITLE: 'Invitar al equipo',
          ROLES_TITLE: 'Roles',
          YOUR_ROLE: 'Tu rol',
          ROLE_SUB_fleet_owner: 'Todo, incluido el dinero y el equipo',
          ROLE_SUB_fleet_manager: 'La operación del día a día',
          ROLE_SUB_fleet_accountant: 'Solo dinero y papeles',
          AREA_DRIVERS_VEHICLES: 'Conductores y vehículos',
          AREA_DOCUMENTS: 'Documentos',
          AREA_MONEY: 'Liquidaciones y wallet',
          AREA_REPORTS: 'Informes',
          AREA_TEAM_SETTINGS: 'Equipo y ajustes',
          COL_LAST_SEEN: 'Último acceso',
          INVITED_ON: 'Invitado el {{date}}',
          RESEND: 'Reenviar',
          RESENT: 'Reenviada',
          RESEND_ERROR: 'No se ha podido reenviar la invitación',
          ROLE_ERROR: 'No se ha podido cambiar el rol',
          ALREADY_MEMBER: '{{email}} ya está en el equipo.',
          NAME: 'Nombre',
          NAME_PLACEHOLDER: 'Nombre y apellidos',
          EMAIL_PLACEHOLDER: 'nombre@empresa.com',
        },
        SETTINGS: {
          BANK_TITLE: 'Cuenta bancaria',
          BANK_SUB: 'Donde cobras las liquidaciones.',
          CHANGE_IBAN: 'Cambiar el IBAN',
          IBAN_HINT: 'Si cambias el IBAN te pediremos un certificado de titularidad nuevo, y lo revisamos antes de usarlo.',
          NEW_IBAN: 'IBAN nuevo',
          IBAN_INVALID: 'Escribe un IBAN español: ES y 22 cifras.',
          IBAN_CERT_HINT: 'Del banco, a nombre de la empresa, con el IBAN nuevo visible.',
          SAVE_IBAN: 'Guardar IBAN y certificado',
          RULES_TITLE: 'Reglas',
          RULES_SUB: 'Se aplican a todos los conductores de la flota.',
          RULE_expiryReminders: 'Avisar antes de que caduque un documento',
          RULE_expiryReminders_HINT: '30 y 7 días antes, al conductor y a ti',
          RULE_blockOnExpiry: 'Bloquear al caducar',
          RULE_blockOnExpiry_HINT: 'El conductor no se conecta hasta renovar. El coche queda libre.',
          RULE_acceptCash: 'Aceptar efectivo',
          RULE_acceptCash_HINT: 'El conductor lo declara en la app y se descuenta de su liquidación',
          RULE_cancellationAlert: 'Aviso por cancelaciones',
          RULE_cancellationAlert_HINT: 'Si un conductor pasa del 5 % en la semana',
        },
        ONBOARDING: {
          ENTITY_NOTE: 'Elige Empresa si facturas con una sociedad (SL, SA, cooperativa…), aunque seas el único socio. Elige Autónomo si facturas a tu nombre. Los datos que pedimos cambian según el caso.',
          TAX_ID_HINT: 'El que te asignó Hacienda. Lo usamos en tus facturas.',
          VTC_TAX_ID_NOTE: 'Debe ser el mismo NIF con el que tus autorizaciones VTC están en el Registro del Ministerio. Si no coincide, no podremos comunicar tus hojas de ruta.',
          VTC_ROUTE_SHEETS_NOTE: 'WAIIS comunica por ti cada servicio al Registro del Ministerio. Solo tienes que autorizarnos (te lo pedimos en el paso de apoderamiento). No emitirlas puede suponer una multa.',
          REP_TITLE: 'Representante y flota',
          SIZE_TITLE: 'Tamaño de la flota',
          SIZE_VALUE: '{{vehicles}} vehículos · {{drivers}} conductores',
          SIZE_VEHICLES: 'Vehículos',
          SIZE_DRIVERS: 'Conductores',
          REP_ROLE_LABEL: 'Tu cargo en la empresa',
          REP_PLACEHOLDER: 'Elige tu cargo',
          REP_REQUIRED: 'Elige tu cargo en la empresa.',
          REP_ROLE: {
            sole_admin: 'Administrador único',
            joint_admin: 'Administrador solidario o mancomunado',
            shareholder_25: 'Socio con más del 25 %',
            attorney: 'Apoderado',
          },
          OWNERS_LABEL: 'Socios con más del 25 %',
          OWNER_NAME: 'Nombre y apellidos',
          OWNER_ID: 'DNI / NIE',
          OWNER_ADD: 'Añadir otro socio',
          OWNER_REMOVE: 'Quitar socio',
          OWNERS_INVALID: 'Pon el nombre y un DNI o NIE válido de cada socio.',
          DISCLAIMER_TITLE: 'Acepto el descargo de responsabilidad',
          DISCLAIMER_REQUIRED: 'Acepta el descargo de responsabilidad para guardar.',
          CAPTURE_LIKE_THIS: 'Captura así',
          OPEN_REGISTRY: 'Abrir el Registro VTC',
          NEW_TAB: '(se abre en una pestaña nueva)',
          ROUTE_STEP_1: 'Entra en el Registro VTC del Ministerio con Cl@ve o tu certificado digital.',
          ROUTE_STEP_2: 'En «Autorizar comunicaciones», autoriza el NIF de WAIIS:',
          ROUTE_STEP_3: 'Como tipo, elige «Intermediario / Plataforma» y marca «Gestionar todas mis autorizaciones».',
          ROUTE_STEP_4: 'Haz una captura donde se vean tu NIF y el autorizado, y súbela aquí.',
          COPY: 'Copiar',
          COPIED: 'Copiado',
          SEND_TITLE: 'Enviar a revisión',
          SEND_SUB: 'Lo revisamos en menos de 24 h y te avisamos por correo.',
          MEANWHILE: 'Mientras tanto',
          ON_APPROVAL: 'Al aprobarla',
          MEANWHILE_VEHICLES: 'Añadir vehículos y sus documentos',
          MEANWHILE_CODE: 'Compartir tu código con los conductores',
          MEANWHILE_SHIFTS: 'Crear los turnos',
          APPROVAL_DRIVERS: 'Los conductores pueden conectarse',
          APPROVAL_SETTLEMENTS: 'Empiezan las liquidaciones',
        },
        DRIVERS: {
          TAB_AVAILABLE: 'Libres',
          TAB_ON_TRIP: 'En viaje',
          TAB_OFFLINE: 'Desconectados',
          TAB_PENDING: 'Solicitudes',
          ADD: 'Añadir conductor',
          ADD_SUB: 'Se unen con el código de tu flota desde la app WAIIS Driver.',
          ADD_NOTE: 'Cuando lo introduzcan, te llegará su solicitud aquí. Aceptarla es lo único que tienes que hacer.',
          COPY: 'Copiar',
          COPIED: 'Copiado',
          COPY_MESSAGE: 'Copiar mensaje',
          CHANGE_CODE: 'Cambiar código',
          DONE: 'Hecho',
          STEPS_TITLE: 'Cómo se unen',
          STEP_1: 'Se descargan la app WAIIS Driver y crean su cuenta.',
          STEP_2: 'Suben su DNI, su carnet de conducir y su permiso de conductor profesional.',
          STEP_3: 'En «Unirme a una flota» escriben el código {{code}}.',
          STEP_4: 'Aceptas su solicitud en esta pantalla y ya pueden trabajar en tu flota.',
          MESSAGE_TITLE: 'Mensaje para enviarles',
          JOIN_MESSAGE: '¡Hola! Para trabajar con nosotros, descárgate la app WAIIS Driver, crea tu cuenta y, en «Unirme a una flota», escribe el código {{code}}. En cuanto te aceptemos ya puedes empezar.',
          KPIS_ARIA: 'Resumen de conductores',
          KPI_ONLINE: 'Conectados ahora',
          SEARCH: 'Buscar por nombre, teléfono o matrícula',
          COL_STATE: 'Estado',
          COL_NEXT: 'Siguiente paso',
          COL_VEHICLE: 'Vehículo',
          COL_SHIFT: 'Turno',
          COL_TRIPS: 'Viajes',
          COL_RATING: 'Valoración',
          COL_WEEK: '€ semana',
          EMPTY_all: 'Aún no tienes conductores. Pásales el código de la flota para que se unan.',
          EMPTY_available: 'Ahora mismo no hay nadie libre.',
          EMPTY_on_trip: 'Ahora mismo no hay nadie en viaje.',
          EMPTY_offline: 'Todos tus conductores están conectados.',
          EMPTY_pending: 'No hay solicitudes pendientes.',
          EMPTY_with_alerts: 'Ningún conductor tiene documentos por renovar.',
          YOU: 'Tú',
          STATE_PENDING: 'Solicitud',
          STATE_REJECTED: 'Rechazado',
          STATE_INACTIVE: 'Desactivado',
          STATE_READY: 'Listo',
          STATE_VERIFYING: 'Verificando',
          STATE_ON_TRIP: 'En viaje',
          STATE_AVAILABLE: 'Libre',
          STATE_OFFLINE: 'Desconectado',
          NEXT_ACCEPT: 'Acepta su solicitud',
          NEXT_APPROVAL: 'Esperando a que WAIIS apruebe la flota',
          NEXT_VERIFY: 'WAIIS revisa sus documentos',
          DOCS_ok: 'Al día',
          DOCS_warn: 'Caduca pronto',
          DOCS_bad: 'Caducado o rechazado',
          DOCS_review: 'En revisión',
          DOCS_missing: 'Faltan',
          PENDING_NOTE: 'Pidió unirse a la flota el {{date}}. Revisa sus datos y acepta o rechaza la solicitud.',
          STAT_HOURS: 'Conectado',
          VEHICLE_TITLE: 'Vehículo',
          VEHICLE_SHIFT_TITLE: 'Vehículo y turno',
          NO_VEHICLE: 'Sin vehículo asignado',
          NO_SHIFT: 'Sin turno',
          EDIT_SHIFTS: 'Editar turnos',
          SHARE_TITLE: 'Reparto',
          SHARE_PERCENT: 'Porcentaje',
          SHARE_SPLIT: 'Conductor {{driver}} % · Flota {{fleet}} %',
          SALARIED_NOTE: 'Cobra una nómina: la flota se queda con lo que facture.',
          SHARE_RANGE: 'El porcentaje tiene que estar entre 30 y 80.',
          UNLINK: 'Desvincular',
          DEACTIVATE: 'Desactivar',
          REACTIVATE: 'Reactivar',
          DEACTIVATE_TITLE: '¿Desactivar a {{name}}?',
          REACTIVATE_TITLE: '¿Reactivar a {{name}}?',
          DEACTIVATE_TEXT: 'No podrá conectarse ni recibir viajes de la flota hasta que lo reactives. Sigue vinculado y conserva sus turnos.',
          REACTIVATE_TEXT: 'Podrá volver a conectarse y recibir viajes de la flota.',
        },
        REVIEW_BAR: {
          IN_REVIEW_TITLE: 'Flota en revisión',
          IN_REVIEW_TEXT: 'Añade vehículos y comparte tu código con los conductores. Podrán conectarse cuando la aprobemos.',
          REJECTED_TITLE: 'Hay algo rechazado',
          REJECTED_REST: 'Lo demás sigue en revisión.',
          STEPS_ARIA: 'Pasos del alta',
          STEP_billing_info: 'Facturación',
          STEP_bank_ownership_certificate: 'Banco',
          STEP_route_sheet_authorization: 'Hojas de ruta',
          SEE_STATUS: 'Ver estado',
          FIX: 'Volver a subir',
          START_WHILE_REVIEW: 'Puedes hacerlo ya: tus conductores podrán conectarse en cuanto aprobemos la flota.',
        },
        ACTIVE: 'Activa',
        INACTIVE: 'Inactiva',
        REFRESH: 'Actualizar',
        SHOW_MORE: 'Ver más',
        COL_UPDATED: 'Actualizada',
        DELETING: 'Borrando…',
        DELETED: 'Borrado',
        REASON_PLACEHOLDER: 'Motivo (obligatorio, queda en la auditoría)',
        REASON_REQUIRED: 'Indica el motivo.',
        ASSOCIATE_NOTE: 'Entra como socio de la emisora: trabaja con su licencia y su coche y cobra sus viajes íntegros.',
        ACCEPT_ASSOCIATE_TITLE: 'Aceptar como socio',
        SHARE_ASSOCIATE: 'No aplica (socio: cobra íntegro)',
        STANDS: {
          ADD: 'Nueva parada',
          LIST_TITLE: 'Paradas',
          LIST_SUB: 'Al entrar en la geocerca, el taxista se pone en la cola de esa parada.',
          COL_NAME: 'Nombre',
          COL_QUEUE: 'En cola',
          COL_CAPACITY: 'Capacidad',
          EMPTY: 'Todavía no hay paradas.',
          LOAD_ERROR: 'No se han podido cargar las paradas.',
          QUEUE_TITLE: 'Cola de {{name}}',
          QUEUE_SUB: 'En vivo: se actualiza sola cada 15 segundos.',
          QUEUE_EMPTY: 'No hay nadie en la cola.',
          QUEUE_ERROR: 'No se ha podido cargar la cola.',
          QUEUE_RULES: 'Reglas de la cola: tras los rechazos seguidos que marca la política de reparto, el taxista sale con un aviso; saltar una oferta por requisitos no le hace perder el sitio. Rechazar nunca multa.',
          WAITING: 'esperando {{minutes}} min',
          REJECTIONS: 'Rechazos seguidos: {{count}}',
          REJECTIONS_TIP: 'Ofertas rechazadas seguidas desde que entró en la cola.',
          SKIPS: 'Saltos por requisitos: {{count}}',
          SKIPS_TIP: 'Ofertas que no podía hacer (PMR, mascota…): no cuentan como rechazo.',
          REMOVE: 'Sacar de la cola',
          REMOVING: 'Sacando…',
          REMOVED: 'Fuera de la cola',
          REMOVE_TITLE: 'Sacar a {{name}} de la cola',
          REMOVE_TEXT: 'Saldrá de la cola de {{stand}} y recibirá un aviso.',
          REMOVE_PLACEHOLDER: 'Motivo (obligatorio, lo verá el taxista)',
          REMOVE_ERROR: 'No se ha podido sacar de la cola',
          DRAWER_SUB: 'Dibuja la geocerca y coloca el punto de la parada.',
          DATA_TITLE: 'Datos de la parada',
          ADDRESS: 'Dirección',
          CAPACITY_HINT: 'Orientativa: no echa a nadie de la cola.',
          CAPACITY_INVALID: 'Entre 1 y 50.',
          ACTIVE_LABEL: 'Parada activa',
          GEOFENCE_TITLE: 'Geocerca y punto',
          GEOFENCE_HINT: 'La zona en la que el taxista entra en la cola. El punto es lo que se ve en el mapa y en la app.',
          POINT_INVALID: 'El punto de la parada tiene que estar dentro de su geocerca.',
          CREATE: 'Crear parada',
          DELETE: 'Borrar parada',
          DELETE_TITLE: 'Borrar la parada {{name}}',
          DELETE_TEXT: 'Se vacía su cola y los taxistas que estaban en ella reciben un aviso.',
          DELETE_ERROR: 'No se ha podido borrar la parada',
          DELETED_QUEUE: 'Parada borrada. Han salido de la cola {{count}} taxistas.',
        },
        ZONES: {
          ADD: 'Nueva zona',
          TITLE: 'Zonas',
          SUB: 'Las usan el reparto «Por zona» y los informes. Pueden solaparse: gana la más pequeña.',
          COL_NAME: 'Nombre',
          COL_POINTS: 'Puntos',
          EMPTY: 'Todavía no hay zonas.',
          LOAD_ERROR: 'No se han podido cargar las zonas.',
          DRAWER_SUB: 'Dibuja la zona en el mapa. De fondo, las demás.',
          ACTIVE_LABEL: 'Zona activa',
          SHAPE_TITLE: 'Forma de la zona',
          CREATE: 'Crear zona',
          DELETE: 'Borrar zona',
          DELETE_TITLE: 'Borrar la zona {{name}}',
          DELETE_TEXT: 'Deja de usarse en el reparto. Los viajes pasados no cambian.',
          DELETE_ERROR: 'No se ha podido borrar la zona',
        },
        POLICY: {
          LOAD_ERROR: 'No se ha podido cargar la política de reparto.',
          NOTE_TITLE: 'Rechazar nunca multa',
          NOTE_TEXT: 'Estos valores solo ordenan a quién se ofrece cada servicio. Cada cambio queda en el historial con su autor.',
          STRATEGY_TITLE: 'Cómo se reparten los servicios',
          STRATEGY_SUB: 'A quién se ofrece primero cada servicio entre los socios disponibles.',
          STRATEGY_HINT_proximity: 'Al socio libre más cercano al origen.',
          STRATEGY_HINT_stand_order: 'Al primero de la cola de la parada más cercana; si no hay cola, al más cercano.',
          STRATEGY_HINT_zone: 'Primero a los socios de la zona del origen, por orden de llegada a la zona.',
          INTRA_FLEET: 'Los socios de la emisora reciben las ofertas antes que otros conductores WAIIS',
          QUEUE_TITLE: 'Ofertas y cola',
          QUEUE_SUB: 'Cuánto dura cada oferta y cuándo sale alguien de la cola de una parada.',
          TIMEOUT_HINT: 'Tiempo para aceptar una oferta antes de pasar al siguiente (10–60 s).',
          TIMEOUT_INVALID: 'Entre 10 y 60 segundos.',
          REJECTIONS_HINT: 'Rechazos seguidos tras los que el taxista sale de la cola con un aviso (1–5).',
          REJECTIONS_INVALID: 'Entre 1 y 5.',
          LAST_CHANGE: 'Último cambio: {{name}}, {{date}}.',
          OUTDATED_TITLE: 'La política ha cambiado',
          HISTORY_TITLE: 'Historial de cambios',
          HISTORY_SUB: 'Quién cambió qué y cuándo.',
          HISTORY_EMPTY: 'Todavía no hay cambios.',
          FIELD: {
            strategy: 'Reparto',
            intra_fleet_priority: 'Prioridad a los socios',
            offer_timeout_seconds: 'Tiempo de cada oferta',
            stand_max_consecutive_rejections: 'Rechazos seguidos para salir de la cola',
            skip_by_requirements_keeps_position: 'Saltar una oferta por requisitos conserva el sitio en la cola',
          },
        },
        FEES: {
          ADD_RULE: 'Nueva regla',
          ADD_RULE_SUB: 'Una cuota para una ciudad, un modo o un tipo de servicio concretos.',
          EDIT_RULE: 'Cambiar la cuota',
          NOTE_TITLE: 'Solo paga cuota la demanda que genera WAIIS',
          NOTE_TEXT:
            'Se suma al precio del viaje: el taxista o la flota cobran la tarifa íntegra. Los clientes propios de la emisora (su teléfono, su web, la parada y la calle) van siempre a 0 €. La cuota se congela al crear el viaje.',
          LOAD_ERROR: 'No se ha podido cargar la cuota al pasajero.',
          MATRIX_TITLE: 'Importes',
          MATRIX_SUB: 'Las reglas generales valen para todas las ciudades; las demás las afinan.',
          COL_SERVICE: 'Tipo de servicio',
          COL_AMOUNT: 'Cuota',
          COL_CHANNEL: 'Canal',
          COL_STATE: 'Cuota',
          COL_REASON: 'Motivo',
          GENERAL: 'General',
          PRIORITY: 'Para un viaje gana la regla más concreta: ciudad y modo, después ciudad, después modo y por último la general.',
          AMOUNT_HINT: 'De 0 a 10 €. Con 0 € no se cobra cuota.',
          AMOUNT_INVALID: 'Pon un importe entre 0 y 10 €.',
          DUPLICATE: 'Ya hay una regla para esa ciudad, modo y tipo de servicio: cambia su importe.',
          REQUIRED_RULE: 'Las reglas generales no se borran: ponlas a 0 €.',
          SAVE_ERROR: 'No se ha podido guardar la cuota',
          DELETE: 'Borrar regla',
          DELETE_TITLE: 'Borrar la regla',
          DELETE_TEXT: '{{rule}}. A partir de ahora se aplica la regla más general que quede.',
          DELETE_ERROR: 'No se ha podido borrar la regla',
          REGIONS_TITLE: 'Interruptor por ciudad',
          REGIONS_SUB: 'Con la cuota apagada, los pasajeros de esa ciudad pagan 0 € aunque haya reglas. Activa en {{enabled}} de {{total}}.',
          ON: 'Activa',
          OFF: 'Apagada',
          ENABLE: 'Activar',
          DISABLE: 'Apagar',
          ENABLE_TITLE: 'Activar la cuota en {{region}}',
          ENABLE_TEXT: 'Los viajes que se creen a partir de ahora con la app WAIIS pagarán la cuota de la matriz.',
          DISABLE_TITLE: 'Apagar la cuota en {{region}}',
          DISABLE_TEXT: 'Los viajes que se creen a partir de ahora irán a 0 €. Los ya creados no cambian.',
          SIM_TITLE: 'Simulador',
          SIM_SUB: 'Lo que pagaría un pasajero con la matriz de ahora.',
          FARE: 'Precio del viaje',
          SIMULATE: 'Calcular',
          SIM_INVALID: 'Elige una ciudad y pon un precio.',
          PASSENGER_TOTAL: 'Paga el pasajero',
          REASON: {
            rule: 'Regla aplicada: {{rule}}.',
            channel_exempt: 'Cliente propio de la emisora: sin cuota.',
            region_disabled: 'La cuota está apagada en esta ciudad.',
            no_rule: 'No hay regla para este tipo de servicio: sin cuota.',
          },
          HISTORY_TITLE: 'Auditoría',
          HISTORY_SUB: 'Todos los cambios de la matriz y de los interruptores.',
          ACTION: {
            rule_created: 'Nueva regla «{{target}}»: {{to}}',
            rule_updated: 'Regla «{{target}}»: {{from}} → {{to}}',
            rule_deleted: 'Regla borrada «{{target}}» (era {{from}})',
            region_toggled: '{{target}}: cuota {{from}} → {{to}}',
          },
        },
        CHALLENGES: {
          ADD: 'Nuevo reto',
          TABS_ARIA: 'Estado de los retos',
          TAB_ALL: 'Todos',
          PANEL_TITLE: 'Retos',
          PANEL_SUB: 'El bono se abona solo en la cartera del conductor cuando cumple el reto.',
          SEARCH: 'Buscar por título',
          COL_CHALLENGE: 'Reto',
          COL_SCOPE: 'Para',
          COL_GOALS: 'Objetivos',
          COL_BONUS: 'Bono',
          COL_COMPLETED: 'Cumplido',
          EMPTY: 'No hay retos con estos filtros.',
          LOAD_ERROR: 'No se han podido cargar los retos.',
          LOAD_ONE_ERROR: 'No se ha podido cargar el reto.',
          SHOWING: 'Mostrando {{shown}} de {{total}} retos',
          PER_PAGE: '{{count}} por página',
          PER_PAGE_ARIA: 'Retos por página',
          GOAL_TRIPS: '{{value}} viajes',
          GOAL_HOURS: '{{value}} h conectado',
          GOAL_FARE: '{{value}} facturados',
          GOAL_RATING: 'valoración ≥ {{value}}',
          NEW_TITLE: 'Nuevo reto',
          DETAIL_TITLE: 'Reto',
          BACK: 'Volver a retos',
          SECTION_WHAT: 'El reto',
          SECTION_WHO: 'Para quién y cuándo',
          SECTION_GOALS: 'Objetivos',
          SECTION_BONUS: 'Bono',
          TITLE: 'Título',
          DESCRIPTION: 'Descripción',
          DESCRIPTION_HINT: 'Lo que verá el conductor en la app.',
          STARTS: 'Empieza',
          ENDS: 'Termina',
          DATES_INVALID: 'Pon el inicio y el fin, y que el fin no sea antes del inicio.',
          GOALS_HINT: 'Rellena los que cuenten: hay que cumplirlos todos.',
          MIN_TRIPS: 'Viajes',
          MIN_HOURS: 'Horas conectado',
          MIN_FARE: 'Facturación (€)',
          MIN_RATING: 'Valoración mínima',
          GOALS_INVALID: 'Pon al menos un objetivo (la valoración, de 1 a 5).',
          BONUS_HINT: 'De 1 a 500 €. Se abona en la cartera (línea BONUS).',
          BONUS_INVALID: 'Pon un bono entre 1 y 500 €.',
          CREATE: 'Crear reto',
          SAVED_TITLE: 'Reto guardado',
          SAVE_ERROR: 'No se ha podido guardar el reto.',
          LOCKED: 'Este reto ya ha empezado: no se puede cambiar.',
          PUBLISH: 'Publicar',
          PUBLISH_TITLE: 'Publicar «{{title}}»',
          PUBLISH_TEXT: 'Se avisará a los conductores de esa ciudad y modo. Hasta que empiece, aún se puede editar.',
          CANCEL: 'Cancelar el reto',
          CANCEL_TITLE: 'Cancelar «{{title}}»',
          CANCEL_TEXT: 'Deja de contar para todos. Los bonos ya pagados no se retiran.',
          DELETE: 'Borrar',
          DELETE_TITLE: 'Borrar «{{title}}»',
          DELETE_TEXT: 'Es un borrador: nadie lo ha visto todavía.',
          ACTION_ERROR: 'No se ha podido completar la acción',
          PARTICIPANTS: 'Participantes',
          PARTICIPANTS_SUB: 'Progreso de cada conductor. En verde, lo que ya ha cumplido.',
          PARTICIPANTS_EMPTY: 'Todavía no participa nadie.',
          PAID: 'Bonos pagados',
          PARTICIPANT_in_progress: 'En curso',
          PARTICIPANT_completed: 'Cumplido, bono pendiente',
          PARTICIPANT_paid: 'Bono pagado',
        },
      },
    },
    SIDEBAR: {
      FLEET_PERFORMANCE: 'Rendimiento',
      FLEET_DRIVERS_COUNT: 'Solicitudes por aceptar: {{count}}',
      FLEET_DOCUMENTS_COUNT: 'Documentos que necesitan atención: {{count}}',
      FLEET_DISPATCH_SECTION: 'Emisora',
      FLEET_STANDS: 'Paradas',
      FLEET_ZONES: 'Zonas',
      FLEET_DISPATCH_POLICY: 'Política de reparto',
      FLEET_DATA_SECTION: 'Datos',
      PASSENGER_FEES: 'Cuota al pasajero',
      DRIVER_CHALLENGES: 'Retos',
    },
    PAGE_HEADER: {
      FLEET_PERFORMANCE: 'Cómo trabaja cada conductor: viajes, horas, facturación, aceptación y valoración.',
      FLEET_STANDS: 'Las paradas de la emisora con su geocerca y su cola en vivo.',
      FLEET_ZONES: 'Las zonas con nombre de la emisora, para el reparto y los informes.',
      FLEET_DISPATCH_POLICY: 'Cómo se ofrecen los servicios entre los socios y las reglas de la cola.',
      PASSENGER_FEES: 'Cuánto paga el pasajero encima del precio según la ciudad, el modo y el tipo de servicio.',
      DRIVER_CHALLENGES: 'Retos con bono en € para conductores de taxi y VTC.',
    },
  },
};
